import React, { memo } from "react";
import { PartProps } from "../types";
import { useResult } from "../useData";
import { data, QuestionDatum, description } from "./data";
import Question from "./Question";
import { ResultValue, Part1ResultDatum } from "./types";
import { Pages } from "../Pages";
import { NavigationButtons } from "../components/NavigationButtons";
import { PartTitle } from "../components/PartTitle";

function Part1({ onPartFinish }: PartProps) {
  const {
    current,
    currentIndex,
    all,
    addResult,
    currentResult,
    allResults,
    totalCount,
    ...navigationProps
  } = useResult<ResultValue, QuestionDatum>(data, Pages.Part1);

  const handlePartFinish = () =>
    onPartFinish(all.map((_, index): Part1ResultDatum => allResults[index]));

  const handleResult = (result: ResultValue) => {
    addResult(result);
  };

  return (
    <>
      <PartTitle
        descriptionTranslation={description}
        part={Pages.Part1}
        finished={allResults.length}
        total={totalCount}
        currentIndex={currentIndex}
      />
      <Question
        index={currentIndex}
        question={current}
        onAnswer={handleResult}
        result={currentResult}
      />
      <NavigationButtons
        handlePartFinish={handlePartFinish}
        {...navigationProps}
      />
    </>
  );
}

export default memo(Part1);
